const dateRegex = new RegExp(
  "^(19|20)[0-9]{2}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$"
)
export const isDateValid = (string: string): boolean => dateRegex.test(string)
